module.exports = __webpack_public_path__ + "media/images/icons/verified-5f8bbedebc78222c8df7d43e6a1b7c30.svg";